import { createFileRoute } from '@tanstack/react-router';
import { LegacyReportHandoff } from '@/pages/workspaces/analysis/report/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/** The pre-rename twin of `/journeys/reports`, which behaves identically. */
function JourneysAnalysisIndexRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <LegacyReportHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/analysis/')({
  component: JourneysAnalysisIndexRoute,
});
